module.exports = __webpack_public_path__ + "static/media/FAQ.36d4c131.png";